const Footer=()=>{
    return <footer className="bg-light-blue flex flex-row ">
        
    <p className ="text-[12px] p-4 ">2023 Donkey_Hot Team</p>
    
    </footer>
}
export default Footer